import { Button } from '@mui/material';
import { InputController } from '../../../components';

export const MaterialEditForm = ({
  register,
  errors,
  onSubmit,
  handleClose,
  handleSubmit,
}) => {
  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="grid grid-cols-2 gap-x-10">
      <InputController
        label="Crop Code"
        register={register('cropCode')}
        error={errors?.cropCode?.message}
        required
      />
      <InputController
        label="Crop Name"
        register={register('cropName')}
        error={errors?.cropName?.message}
        required
      />
      <InputController
        label="Status"
        register={register('status')}
        error={errors?.status?.message}
        required
      />
      <InputController
        label="Division"
        register={register('division')}
        error={errors?.division?.message}
        required
      />
      <InputController
        label="Basic Material"
        register={register('basicMaterial')}
        error={errors?.basicMaterial?.message}
        required
      />
      <InputController
        label="Hybrid name"
        register={register('hybridName')}
        error={errors?.hybridName?.message}
        required
      />
      <InputController
        label="Hybrid Material Code"
        register={register('hybridMaterialCode')}
        error={errors?.hybridMaterialCode?.message}
        required
      />
      <InputController
        label="Hybrid Commercial Name"
        register={register('hybridCommercialName')}
        error={errors?.hybridCommercialName?.message}
        required
      />
      <InputController
        label="Hybrid Production Code"
        register={register('hybridProductionCode')}
        error={errors?.hybridProductionCode?.message}
        required
      />
      <InputController
        label="Productivity/acre"
        register={register('productivityAcre')}
        error={errors?.productivityAcre?.message}
        required
      />
      <InputController
        label="Life of Crop"
        register={register('lifeOfCrop')}
        error={errors?.lifeOfCrop?.message}
        required
      />
      <InputController
        label="Country"
        register={register('country')}
        error={errors?.country?.message}
        required
      />
      <InputController
        label="Season"
        register={register('season')}
        error={errors?.season?.message}
        required
      />

      <div className="col-span-full mt-8 flex justify-end">
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          type="submit"
          sx={{
            ml: 2,
            backgroundColor: 'rgba(0,105,112,1)',
          }}>
          Save
        </Button>
      </div>
    </form>
  );
};
